import React from 'react'
import Store from './src/Store'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/700.css'

export const wrapRootElement = ({ element }) => <Store>{element}</Store>
